module.exports = __webpack_public_path__ + "img/Icon=Java.46578b3b.svg";